<template>
  <div>
    <Title v-if="!isAdmin" :showMinister="true" :showService="true" />

    <Breadcrumb :links="breadCrumbData" />

    <Carrusel />
    <Button />
    <div class="container">
      <div v-if="permiso" style="display: flex; justify-content: flex-end;">
        <Watch :msg="alertMessage" />
      </div>

      <MainTramite v-if="!this.routerPath" :readOnly="permiso" />
      <MainPromulgadas v-else :readOnly="permiso" />
    </div>
  </div>
</template>

<script>
import Title from "../../../components/private/Title";
import Breadcrumb from "@/components/tools/Breadcrumb.vue";
import MainTramite from "./v-if/LeyesTramite/Main.vue";
import MainPromulgadas from "./v-if/LeyesPromulgadas/Main.vue";
import Watch from "../../../components/alert/Watch.vue";
import Carrusel from "../../../components/private/Carrusel.vue";
import Button from "./Button.vue";
import { mapState } from "vuex";
import axios from "axios";

export default {
  components: {
    Title,
    Breadcrumb,
    MainTramite,
    MainPromulgadas,
    Watch,
    Carrusel,
    Button,
  },
  data() {
    return {
      breadCrumbData: null,
      permiso: true,
      userPermissions: true,
      userPermission: true,
      alertMessage:
        "Esta sección debe ser llenada únicamente por el representante Ministerial. No estás autorizado para completar este contenido, sólopuedes visualizarlo.",
    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
    routerPath: function() {
      const { path } = this.$route;

      return path.includes("/promulgadas");
    },
  },
  methods: {
    setBreadcrumbData: function() {
      this.breadCrumbData = [
        {
          name: "Portada BGI",
          routeName: "bgi",
          routeParams: {
            idUsuario: this.usuario.id,
          },
        },
        {
          name: "Escritorio de Gestión Virtual",
          routeName: "buttons",
          routeParams: {
            idUsuario: this.usuario.id,
            idServicio: this.$route.params.idServicio,
          },
        },
        {
          name: "Leyes",
          routeName: "leyes",
          routeParams: {
            idServicio: this.$route.params.idServicio,
          },
        },
      ];
    },
    obtenerRelacionUsuarioServicio() {
      const data = JSON.parse(localStorage.getItem("user"));
      const relacionUs = data.servicios.find(
        (s) => s.id === parseInt(this.$route.params.idServicio)
      );
      if (!relacionUs) return;
      if (
        relacionUs.rolId === 3 ||
        relacionUs.rolId === 4 ||
         relacionUs.rolId === 5 ||
        relacionUs.permisos.find((p) => p.permisoId === 13)
      ) {
        this.permiso = false;
      }
    },
    obtenerContenido: async function() {
      try {
        const obj = {
          anio: process.env.VUE_APP_ANIO,
          nombre: "leyes",
        };
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${obj.anio}&nombre=${obj.nombre}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data) {
          this.contenidoLock = res.data.info.content;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.setBreadcrumbData();
    this.obtenerRelacionUsuarioServicio();
  },
};
</script>

<style scoped>
.watch {
  height: 150px;
}
</style>
